import * as actionTypes from './actionTypes';
import axios from '../../http/axios';
import { modifyAuthError } from '../../utils/utils';


const authSuccess = data => {
    return {
        type: actionTypes.AUTH_SUCCESS,
        payload: data
    };
};

const authFailed = error => {
    return {
        type: actionTypes.AUTH_FAIL,
        error: error
    };
};

export const getAuthToken = ({ email, password, doesRemember }) => {
    return dispatch => {
        const authData = { email, password };
        const url = '/admins/login/';
        dispatch({ type: 'REMEMBER', payload: doesRemember });
        axios.post(url, authData).then(response => {
                if (doesRemember) {
                    localStorage.setItem('token', response.data.auth_token);
                    localStorage.setItem('adminName', response.data.name);
                    localStorage.setItem('pk', response.data.pk);
                    localStorage.setItem('show_notification', response.data.show_notification);
                }
                dispatch(authSuccess(response.data));
            }).catch(e => {
                const error = modifyAuthError(e);
                dispatch( authFailed(error) );
            });
    };
};


export const signOut = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('adminName');
    localStorage.removeItem('pk');
    localStorage.removeItem('show_notification');
    return {
        type: actionTypes.AUTH_SIGNOUT
    };
};


export const setAuthRedirectPath = path => {
    const forgotPasswordPath = '/forgot';
    return {
        type: actionTypes.SET_AUTH_REDIRECT_PATH,
        payload: path === forgotPasswordPath ? '/operation-room/map' : path
    };
};

export const authCheckState = () => {
    return dispatch => {
        const auth_token = localStorage.getItem('token');
        if (!auth_token) {
            dispatch(signOut());
        } else {
            const name = localStorage.getItem('adminName');
            const pk = localStorage.getItem('pk');
            const show_notification = localStorage.getItem('show_notification') === 'true';
            dispatch(authSuccess({auth_token, name, pk, show_notification }));
        }
    };
};


// WEBPACK FOOTER //
// ./src/store/actions/auth.js